























import { ApiCreditcard } from '@/models/api/creditcard'
import ActionToPlanCreditcard from '@spa/components/pages/mypage/paid-membership/plans/ActionToPlanCreditcard.vue'
import { PlanGroupViewModel } from '@spa/components/pages/mypage/paid-membership/plans/models/plan-group'
import { Option } from 'fp-ts/lib/Option'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    ActionToPlanCreditcard,
  },
})
export default class NotifyPlanHolding extends Vue {
  @Prop({ required: true })
  readonly group: PlanGroupViewModel

  @Prop({ required: true })
  creditcard: Option<ApiCreditcard>

  get currentPlan() {
    return this.group.currentPlan
  }
}
